// extracted by mini-css-extract-plugin
module.exports = {"overview":"_3fcsNTG","title":"_1l9gwlY"};